<template>
  <div class="device_control_page_wraper">
    <div class="close_img_top public_z_index6">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name public_z_index6 z_ellipsis1">{{objData.remark}}</div>
    <!-- 开关按钮部分 -->
    <div class="device_024_top_btn_wraper">
      <div class="device_left_btn_wraper device024_top_public_btn"  @click="device024BtnHandle(1)">
        <img src="~assets/img/musicControl/music_kaiji.png" alt />
        <span>开机</span>
      </div>
      <div class="device_right_btn_wraper device024_top_public_btn"  @click="device024BtnHandle(2)">
        <img src="~assets/img/musicControl/music_guanji_1.png" alt />
        <span>关机</span>
      </div>
    </div>
    <!-- 音量样式部分 -->
    <div class="volume_wraper">


      <div class="mute_btn device024_public_btn" @click="device024BtnHandle(3)">
        <img src="~assets/img/musicControl/music_jingyin.png" alt />
      </div>
      <div class="decrease_volume_btn device024_public_btn" @click="device024BtnHandle(5)">
        <img src="~assets/img/musicControl/music_jianshao.png" alt />
      </div>
      <progress-bar
        class="progress_bar_024"
        @valueChange="valueChange"
        :width="150"
        :maxValue="100"
        :setValue="userControlData.openStateValue"
      ></progress-bar>
      <div class="increase_volume_btn device024_public_btn" @click="device024BtnHandle(4)">
        <img src="~assets/img/musicControl/music_zengjia.png" alt />
      </div>
    </div>

    <!-- 模式样式部分 -->
    <div class="music_mode_wraper">
      <div class="music_one_mode_wraper"  @click="device024BtnHandle(9)">
        <img src="~assets/img/musicControl/music_shunxu.png" alt />
        <div>顺序播放</div>
      </div>
      <div class="music_one_mode_wraper"  @click="device024BtnHandle(10)">
        <img src="~assets/img/musicControl/music_danqu.png" alt />
        <div>单曲循环</div>
      </div>
      <div class="music_one_mode_wraper"  @click="device024BtnHandle(12)">
        <img src="~assets/img/musicControl/music_liebiao.png" alt />
        <div>列表循环</div>
      </div>
      <div class="music_one_mode_wraper"  @click="device024BtnHandle(11)">
        <img src="~assets/img/musicControl/music_shuiji.png" alt />
        <div>随机播放</div>
      </div>
    </div>
    <!-- 播放样式部分 -->
    <div class="music_bofang_warber">
      <div class="music_one_btn"  @click="device024BtnHandle(7)">
        <img src="~assets/img/musicControl/music_shangyiqu.png" alt />
      </div>
      <div class="music_one_btn music_bofang_zaiting_btn"  @click="device024BtnHandle(13)">
        <img v-show="musicBoFangFlang === 14" src="~assets/img/musicControl/music_bofang.png" alt />
        <img v-show="musicBoFangFlang === 13" src="~assets/img/musicControl/music_zanting.png" alt />
      </div>
      <div class="music_one_btn"  @click="device024BtnHandle(8)">
        <img src="~assets/img/musicControl/music_xiayiqu.png" alt />
      </div>
    </div>
    <!-- 节目源样式部分 -->
    <div class="music_jiemuyuan_wraper">
      <div class="one_jiemuyuan_wraper"  @click="device024BtnHandle(15)">内置音乐</div>
      <div class="one_jiemuyuan_wraper"  @click="device024BtnHandle(16)">AUX音乐</div>
      <div class="one_jiemuyuan_wraper"  @click="device024BtnHandle(17)">SD音乐</div>
      <div class="one_jiemuyuan_wraper"  @click="device024BtnHandle(18)">蓝牙音乐</div>
      <div class="one_jiemuyuan_wraper" @click="device024BtnHandle(20)">在线音乐</div>
      <div class="one_jiemuyuan_wraper" @click="device024BtnHandle(19)">网络电台</div>
    </div>

  </div>
</template>

<script>
///音乐的绝对音量服务端会返回状态值，其他均无状态反馈。需要注意音量加和音量减是针对绝对音量值进行加减的（不需要在用4和5这个命令），需要进行逻辑判断
//还需要注意 播放和暂停是两个命令共用的是一个按钮，但是服务端没有状态反馈。所以需要进行本地缓存逻辑进行翻转（默认第一次进来刷新界面是暂停按钮显示）
/*1：开机 2：关机 3：静音 4，音量加 5：音量减 6：绝对音量7：上一曲8：下一曲9：顺序播放
10：单曲循环 11：随机播放12：列表循环 13：播放 14：暂停 15：内置音乐16：AUX音乐17:SD音乐18：蓝牙
19：网络电台 20：在线音乐*/
// import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import ProgressBar from "components/common/progressbar/progress-bar";
export default {
  data() {
    return {
      userControlData: this.objData,
      // {
      //   openState: this.objData.openState, //*1：开机 2：关机 3：静音4 ....见上面详细说明
      //   openStateValue: this.objData.openStateValue, //绝对音量值 0-100
      //   openStateValue1: this.objData.openStateValue1, ///无用
      //   openStateValue2: this.objData.openStateValue2 ///无用
      // },
      musicBoFangFlang: 14//////播放和暂停按钮的状态缓存  默认是暂停命令
    };
  },
  components: {
    ProgressBar
  },
  props: {
    objData: Object, ///要控制设备的数据
    deviceTemp: {
      ///要显示的当前温度
      default: "--"
    }
  },
  watch: {
    // "objData.openState": {
    //   // deep:true,
    //   handler: function(val) {
    //     ///保证服务器数据和用户设置的数据同步
    //     console.log(val);
    //     this.userControlData.openState = val;
    //   }
    // },
    // "objData.openStateValue": {
    //   // deep:true,
    //   handler: function(val) {
    //     ///保证服务器数据和用户设置的数据同步
    //     console.log(val);
    //     this.userControlData.openStateValue = val;
    //   }
    // },
    // "objData.openStateValue1": {
    //   // deep:true,
    //   handler: function(val) {
    //     ///保证服务器数据和用户设置的数据同步
    //     console.log(val);
    //     this.userControlData.openStateValue1 = val;
    //   }
    // },
    // "objData.openStateValue2": {
    //   // deep:true,
    //   handler: function(val) {
    //     ///保证服务器数据和用户设置的数据同步
    //     console.log(val);
    //     this.userControlData.openStateValue2 = val;
    //   }
    // }
  },

  methods: {
    valueChange(data) {
      console.log("子组件传回的值" + data);
      if (this.userControlData.openStateValue === data) return;
      this.userControlData.openState = 6; ///绝对音量命令
      this.userControlData.openStateValue = data;
      // controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    device024BtnHandle(value) {
      if (value === 4) {
        //增加音量
        this.userControlData.openState = 6; ///绝对音量命令
        this.userControlData.openStateValue++;
        if (this.userControlData.openStateValue >= 100) {
          this.userControlData.openStateValue = 100;
        }
      } else if (value === 5) {
        //减少音量
        this.userControlData.openState = 6; ///绝对音量命令
        this.userControlData.openStateValue--;
        if (this.userControlData.openStateValue <= 0) {
          this.userControlData.openStateValue = 0;
        }
      }else if(value === 3) {
        //静音
        this.userControlData.openStateValue=0;
        this.userControlData.openState = value;
      }else if(value === 13){
        //13播放或14暂停
        if(this.musicBoFangFlang === 14){
          this.userControlData.openState = 13;
          this.musicBoFangFlang =13;
        }else{
          this.userControlData.openState = 14;
          this.musicBoFangFlang =14;
        }
      }
      else {
        this.userControlData.openState = value;
      }

      // controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    determineBtnHandle() {
      // console.log("确定按钮点下了");
      // controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    }
  },
  computed: {}
};
</script>

<style>
/* 节目源样式部分 */
.music_jiemuyuan_wraper {
  width: 100%;
  height: 100px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  color: #f5f5f5;
  font-size: 14px;

}
.one_jiemuyuan_wraper{
  width: 75px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;
}
.one_jiemuyuan_wraper:active {
  background: #a0a3a5;
}
/* 播放样式部分 */
.music_bofang_warber {
  width: 100%;
  height: 100px;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.music_one_btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.music_one_btn img {
  width: 46px;
  height: 46px;
}
.music_one_btn:active {
  background: #a0a3a5;
}
div.music_bofang_zaiting_btn {
  border: 1px solid var(--control-outline-color);
  padding: 3px;
}
div.music_bofang_zaiting_btn img {
  width: 78px;
  height: 78px;
}
/* 模式样式部分 */
.music_mode_wraper {
  width: 100%;
  height: 100px;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.music_one_mode_wraper {
  width: 70px;
  height: 80px;
  border-radius: 4px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #f5f5f5;
  font-size: 14px;
}
.music_one_mode_wraper img {
  width: 34px;
  height: 34px;
}
.music_one_mode_wraper:active {
  background: #a0a3a5;
}

/* 开关按钮样式部分 */
.device_024_top_btn_wraper {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.device024_top_public_btn {
  display: flex;
  justify-content: center;
  align-items: center;

  /* background-color: #f5f5f5; */
  width: 70px;
  height: 35px;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;

  color: #f5f5f5;
  font-size: 14px;
}
.device024_top_public_btn:active{
  background: #a0a3a5;
}
.device024_top_public_btn img {
  width: 21px;
  height: 21px;

  margin-right: 5px;
}
.device_left_btn_wraper {
  margin-right: 160px;
  background-color: #f5f5f5;
  color: #282828;
}
/* 音量按钮部分 */
.volume_wraper {
  width: 100%;
  height: 80px;
  /* line-height: 80px; */
  text-align: center;
  position: relative;
  margin-bottom: 16px;
}
/* .volume_wraper::after{
  content: "";
  display: inline-block;
  height: 1px;
  width: 300px;
  background-color:#999999;

  position: relative;
  top: 75px;
} */
.device024_public_btn {
  display: inline-block;
  background-color: #f5f5f5;
  width: 40px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
}

.device024_public_btn img {
  width: 21px;
  height: 21px;
  margin-top: 4px;
}

.mute_btn {
  position: absolute;
  top: 42px;
  left: 0px;

  border-radius: 12px;
}
.increase_volume_btn {
  position: absolute;
  top: 42px;
  right: 0px;

}
.decrease_volume_btn {
  position: absolute;
  top: 42px;
  left: 53px;
}
.progress_bar_024 {
  display: inline-block;
  position: absolute;
  left: 80px;
}
.device024_public_btn:active {
  background: #a0a3a5;
}
/* 其他 */
</style>
